import { Box, Button } from "@mui/material";
import Text from "../../../components/Text";
import Flex from "../../../components/Flex";

const SignatureSection = ({
  onActionClick,
  signatureData,
}: {
  onActionClick?: () => void;
  signatureData?: any;
}) => {
  return (
    <Box width={"100%"} height={"150px"} position={"relative"}>
      {signatureData ? (
        <img
          src={signatureData}
          alt="signature"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            border: "1px solid #000",
            margin: 0,
            padding: 0,
          }}
        />
      ) : (
        <Flex
          width={"100%"}
          height={"120px"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Text>No signature</Text>
        </Flex>
      )}
      <Button
        variant="contained"
        sx={{
          position: "absolute",
          bottom: 5,
          left: "83%",
          height: "24px",
        }}
        onClick={() => onActionClick?.()}
      >
        {!signatureData ? "Add" : "Edit"}
      </Button>
    </Box>
  );
};

export default SignatureSection;
